import { z } from 'zod'

/**
 * GoHighLevel's own status of an opportunity. Mirrors the `GhlOpportunityStatus`
 * enum in the Prisma schema (`check:enums`).
 *
 * Not to be read as "booked": in the account this integration was designed
 * against, couples who booked sat at every one of these. A venue's GoHighLevel
 * page uses them only to narrow the picker, and shows all four by default. See
 * docs/gohighlevel.spec.md.
 */
export const GHL_OPPORTUNITY_STATUSES = ['open', 'won', 'lost', 'abandoned'] as const

export const ghlOpportunityStatusSchema = z.enum(GHL_OPPORTUNITY_STATUSES)

export type GhlOpportunityStatus = z.infer<typeof ghlOpportunityStatusSchema>

/** How each status is labeled in the app. */
export const GHL_OPPORTUNITY_STATUS_LABEL: Record<GhlOpportunityStatus, string> = {
  open: 'Open',
  won: 'Won',
  lost: 'Lost',
  abandoned: 'Abandoned',
}
